import { useMemo } from 'react'
import { LeadParentHeaderProps } from '../typings'
import { useNotesDrawer } from '../NotesDrawer'
import { useLeadAttachmentsDrawer } from '../LeadAttachmentsDrawer'
import { ISalesFunnelStage } from '@user/store/salesFunnel'
import { useReopenLeadMenuItem } from './useReopenLeadMenuItem'
import { useDeleteLeadMenuItem } from './useDeleteLeadAlertMenuItem'
import { useReassignDialog } from '../ReassignDialog'

type Params = LeadParentHeaderProps & {
  salesFunnelStages: ISalesFunnelStage[]
}

export function useActions(params: Params) {
  const {
    salesFunnelStages,
    lead: { salesFunnelStageId },
  } = params

  const isDisqualified = useMemo(() => {
    const leadStage = salesFunnelStages.find((x) => x.id === salesFunnelStageId)

    return leadStage?.name === 'Disqualified'
  }, [salesFunnelStageId, salesFunnelStages])

  const notesState = useNotesDrawer(params)
  const deleteState = useDeleteLeadMenuItem(params)
  const attachmentsState = useLeadAttachmentsDrawer(params)
  const reopenState = useReopenLeadMenuItem({ ...params, isDisqualified })
  const reassignState = useReassignDialog(params)

  return {
    isDisqualified,
    notesState,
    deleteState,
    attachmentsState,
    reopenState,
    reassignState,
  }
}
